export default "__VITE_ASSET__9fbaff6b__"